export default __webpack_public_path__ + "static/media/ketochickennuggets-wide@3x.7469a643.jpg";